/**
 * 创美药业主应用 - 基于 Ant Design 5.x + Design Token 系统
 */

import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { AppProviders } from './contexts/AppProviders';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import analytics from './utils/analytics';

function App() {
  useEffect(() => {
    // 初始化埋点SDK
    // 使用相对路径，因为 apiClient 已经配置了 baseURL
    analytics.init({
      apiUrl: '/analytics',
      autoTrack: true,
      debug: import.meta.env.DEV, // 开发环境开启调试
    });
  }, []);

  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider 
          router={router} 
          future={{
            v7_startTransition: true,
          }}
        />
      </AppProviders>
    </ErrorBoundary>
  );
}

export default App;
